import React from "react";
import UserForm from "./UserForm";

const EditUser = () => {
  return <UserForm title="Edit User" addUser={false} />;
};

export default EditUser;
